import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Masonry from 'react-masonry-css';

import AOS from "aos";


import PageTitle from "../../components/PageTitle";
import WhiteSquare from "../../components/WhiteSquare";

import CONFIG from "../../config";

interface I_metaInfo {
  [key: string]: {
    subTitle: string;
    description: JSX.Element | JSX.Element[];
  };
}

const metaInfo: I_metaInfo = {
  companystory: { subTitle: '예능/교양', description: <p>다양한 장르와 포맷을 넘나들며 활약해온<br className="show-mobile" /> 국내 최고 수준의 제작진이<br />크리에이티브 역량을 바탕으로 차별화된<br className="show-mobile" /> 예능, 교양, 디지털 콘텐츠를 만듭니다</p>,},
  drama: { subTitle: '드라마', description: <p>국내 최고의 작가 인프라로 원천 IP 확보 및<br /> 그를 기반으로 차별화된<br className="show-mobile" /> 웰메이드 드라마를 만듭니다</p> },
  documentary: { subTitle: '다큐멘터리', description: <p>감독 및 작가의 전문 인프라를 바탕으로<br /> 스토리 기반의 영향력 있는 프로그램을<br className="show-mobile" /> 만듭니다</p> },
};

const Drama = () => {
  const location = useLocation();

  const breakpointColumnsObj = {
    default: 4,
    1200: 6,
    1060: 5,
    960: 4,
    720: 3,
    520: 2
  };

  useEffect(() => {
    AOS.refreshHard();
    // AOS와 Masonry 갱신을 위해 지연시간을 두고 실행
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
      // 필요하다면 Masonry 갱신 로직 추가
    }, 100); // 100ms 후 실행
  });

  return (
    <div className="drama">
      <div className="section-1">
        <div className="background-video">
          {location.pathname === '/companystory' &&
            <video autoPlay loop muted playsInline webkit-playsInline x5-playsInline preload="auto">
              <source
                src={`${CONFIG.FILE_URL()}/storage/video/companystory.mp4`}
                type="video/mp4"
              />
            </video>
          }
          {location.pathname === '/documentary' &&
            <video autoPlay loop muted playsInline webkit-playsInline x5-playsInline preload="auto">
              <source
                src={`${CONFIG.FILE_URL()}/storage/video/documentary.mp4`}
                type="video/mp4"
              />
            </video>
          }
          {location.pathname === '/drama' &&
            <video autoPlay loop muted playsInline webkit-playsInline x5-playsInline preload="auto">
              <source
                src={`${CONFIG.FILE_URL()}/storage/video/drama.mp4`}
                type="video/mp4"
              />
            </video>
          }
        </div>
        <div className="entertainment-link-menu show-pc">
          <div className="menu-title">
            <div>Q</div>
            <div>menu</div>
          </div>
          <div className="menu-button-wrap">
            <Link to="/companystory">
              <div className={`menu-button ${location.pathname === '/companystory' ? 'checked' : ''}`}>예능/교양</div>
            </Link>
            <Link to="/drama">
              <div className={`menu-button ${location.pathname === '/drama' ? 'checked' : ''}`}>드라마</div>
            </Link>
            <Link to="/documentary">
              <div className={`menu-button ${location.pathname === '/documentary' ? 'checked' : ''}`}>다큐멘터리</div>
            </Link>
          </div>
        </div>
        <div>
          <div className="overlay" />
          <PageTitle title={metaInfo[location.pathname.slice(1)].subTitle} subTitle="Entertainment" description={metaInfo[location.pathname.slice(1)].description} />
          <WhiteSquare />
        </div>
      </div>
      <div className="section-2">
        <div className="menu-bar show-mobile">
          <Link to="/companystory">
            <div className={`${location.pathname === '/companystory' ? 'checked' : ''}`}>예능/교양</div>
          </Link>
          <Link to="/drama">
            <div className={`${location.pathname === '/drama' ? 'checked' : ''}`}>드라마</div>
          </Link>
          <Link to="/documentary">
            <div className={`${location.pathname === '/documentary' ? 'checked' : ''}`}>다큐멘터리</div>
          </Link>
        </div>

        {location.pathname === '/companystory' &&
          <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid"
                   columnClassName="my-masonry-grid_column" data-aos="fade-up" data-aos-duration="1000"
                   data-aos-anchor-placement="top-bottom">
          </Masonry>
        }

        {location.pathname === '/documentary' &&
          <Masonry breakpointCols={breakpointColumnsObj} className="my-masonry-grid" columnClassName="my-masonry-grid_column" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement="top-bottom">

          </Masonry>
        }

        {location.pathname === '/drama' &&
          <div>
            <div className="show-pc">
            </div>

            <div className="show-mobile">

            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default Drama;
